module.exports = __webpack_public_path__ + "img/Ingles III.169bad1b.png";